import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Wind, Sparkles } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    step: 'Step 1',
    title: 'Stop the Puffy Morning Cycle',
    desc: "Botanical support helps encourage healthy circulation… So your body doesn't hold onto that swollen, heavy feeling overnight.",
    quote: 'My face looks normal again.',
    icon: <Droplets className="w-8 h-8 text-white" data-id="element-171" />
  }, {
    step: 'Step 2',
    title: 'Feel Clearer and Less Inflamed',
    desc: 'When your body feels stuck, everything feels heavier. LymphoriaX™ supports natural movement and balance… So you feel less sluggish, less swollen, and more like yourself again.',
    icon: <Wind className="w-8 h-8 text-white" data-id="element-172" />
  }, {
    step: 'Step 3',
    title: "Release What's Been Weighing You Down",
    desc: 'No harsh laxatives. No extreme detox. Just gentle daily support that helps you feel: flatter, lighter, refreshed, comfortable again.',
    icon: <Sparkles className="w-8 h-8 text-white" data-id="element-173" />
  }];
  return <section className="py-24 bg-[#1B5E20] text-white" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-176">
          <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-177">
            HOW IT WORKS
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6" data-id="element-178">
            Why Women Feel Puffy <br data-id="element-179" />
            (And How The Body Resets)
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-180">
            LymphoriaX™ supports your body's natural systems that help manage:
            <br data-id="element-181" />
            <span className="text-[#10B981] font-bold" data-id="element-182">
              fluid balance, circulation, and daily release
            </span>
            <br data-id="element-183" />
            So you feel lighter again — naturally.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-184">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/10 relative overflow-hidden" data-id="element-185">
              <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-186">
                <span className="text-9xl font-bold" data-id="element-187">{i + 1}</span>
              </div>

              <div className="relative z-10" data-id="element-188">
                <div className="w-16 h-16 bg-[#10B981] rounded-2xl flex items-center justify-center mb-6 shadow-lg" data-id="element-189">
                  {step.icon}
                </div>
                <div className="text-[#10B981] font-bold uppercase tracking-wide text-sm mb-2" data-id="element-190">
                  {step.step}
                </div>
                <h3 className="text-2xl font-bold mb-4" data-id="element-191">{step.title}</h3>
                <p className="text-gray-300 leading-relaxed mb-4" data-id="element-192">
                  {step.desc}
                </p>
                {step.quote && <div className="bg-white/10 p-4 rounded-xl mt-4" data-id="element-193">
                    <p className="text-sm font-medium italic text-[#10B981]" data-id="element-194">
                      {step.quote}
                    </p>
                  </div>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}